import { ListGroup } from "react-bootstrap";
import { FaHome, FaUserMd, FaHeadset, FaClipboardList, FaCalendarAlt } from "react-icons/fa";
import { TbTicket } from "react-icons/tb";
import { hasPerm } from '../../common/utils';
import { useTranslation } from 'react-i18next';

const MenuInsideSales = ({ pathname, noDashboard, ocultar_prestadores }) => {
  const { t } = useTranslation(['menu']);

  return (
    <>
        {!noDashboard && (
            <ListGroup variant="flush">
            <ListGroup.Item action href="/home" className="itemMenu" active={pathname.indexOf("/home") !== -1 || pathname === "/"} >
                <FaHome /> {t('menu:item.home')}
            </ListGroup.Item>
            </ListGroup>
        )}

        <div className="list-divider">
            <p>{t('menu:section.insideSales')}</p>
        </div>

        {hasPerm("view_prestadores") && !ocultar_prestadores && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/medicos" className="itemMenu" active={pathname.indexOf("/medicos") !== -1} >
              <FaUserMd /> {t('menu:item.doctors')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {/* Novas Seções */}
        <ListGroup variant="flush">
            <ListGroup.Item action href="/ocorrencias" className="itemMenu" active={pathname.indexOf("/ocorrencias") !== -1} >
                <FaHeadset /> {t('menu:item.occurrences')}
            </ListGroup.Item>
        </ListGroup>

        <ListGroup variant="flush">
            <ListGroup.Item action href="/visitas" className="itemMenu" active={pathname.indexOf("/visitas") !== -1} >
                <FaClipboardList /> {t('menu:item.visits')}
            </ListGroup.Item>
        </ListGroup>

        <div className="list-divider">
            <p>Configurações</p>
        </div>

        {hasPerm('view_feriado') && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/feriados" className="itemMenu" active={pathname.indexOf('/feriados') !== -1}>
                <FaCalendarAlt /> Feriados
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_chamados") && (
          <>
            <div className="list-divider">
                <p>{t('menu:section.support')}</p>
            </div>
            <ListGroup variant="flush">
              <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
                <TbTicket /> {t('menu:item.tickets')}
              </ListGroup.Item>
            </ListGroup>
          </>
        )}
    </>
  );
};

export default MenuInsideSales;
